// extracted by mini-css-extract-plugin
export default {"contactContainer":"ContactForm_contactContainer__xqjt2","info":"ContactForm_info__FL2Kw","form":"ContactForm_form__mIkXn"};